/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Fit_3Inputs */

const en_pc_alt_fit_3 = /** @type {(inputs: Pc_Alt_Fit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You use Linux or FreeBSD, where Adobe Acrobat has no desktop app.`)
};

const zh_pc_alt_fit_3 = /** @type {(inputs: Pc_Alt_Fit_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你使用 Linux 或 FreeBSD，而 Adobe Acrobat 在这些系统上没有桌面版。`)
};

/**
* | output |
* | --- |
* | "You use Linux or FreeBSD, where Adobe Acrobat has no desktop app." |
*
* @param {Pc_Alt_Fit_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_fit_3 = /** @type {((inputs?: Pc_Alt_Fit_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Fit_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_fit_3(inputs)
	return zh_pc_alt_fit_3(inputs)
});
export { pc_alt_fit_3 as "pc.alt.fit.3" }